<ion-header>
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-button (click)="close()" *ngIf="canClose">
        <ion-icon src="assets/fa-light/times.svg" slot="start"></ion-icon>{{'sa_close' | translate}}
      </ion-button>
    </ion-buttons>
    <ion-buttons slot="end">
      <ion-button [disabled]="!password.value || !repeat.value || password.value !== repeat.value" (click)="savePassword(password.value, repeat.value)">
        <ion-icon slot="start" src="assets/fa-light/check-circle.svg"></ion-icon>
        {{'sa_save' | translate}}
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-card mode="md">
    <ion-list-header mode="ios">
      <ion-label>{{'sa_change_password_title' | translate}}</ion-label>
      <ion-icon class="list-header-icon" src="assets/fa-light/asterisk.svg"></ion-icon>
    </ion-list-header>
    <ion-list>
      <ion-item>
        <ion-label position="stacked">{{'sa_new_password_input_label' | translate}}</ion-label>
        <ion-input #password type="password"></ion-input>
      </ion-item>

      <ion-item>
        <ion-label position="stacked">{{'sa_repeat_password_input_label' | translate}}</ion-label>
        <ion-input #repeat type="password"></ion-input>
      </ion-item>

    </ion-list>
  </ion-card>
</ion-content>